/**
 * @generated SignedSource<<132585f554798e7d10d1cb2936863b81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedProductAdWrapper_itemSearch$data = {
  readonly displayUriRef: string | null;
  readonly " $fragmentType": "SbSharedProductAdWrapper_itemSearch";
};
export type SbSharedProductAdWrapper_itemSearch$key = {
  readonly " $data"?: SbSharedProductAdWrapper_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedProductAdWrapper_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedProductAdWrapper_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "9eb681dd367c76ba1ef66fe4ad68e322";

export default node;
